import {
  Environment,
  OrbitControls,
  PerspectiveCamera,
} from "@react-three/drei";
import { Canvas, useFrame } from "@react-three/fiber";
import {
  BrightnessContrast,
  EffectComposer,
} from "@react-three/postprocessing";
import { Perf } from "r3f-perf";
import { useContext, useEffect, useRef, useState } from "react";
import CurrentContext from "../../utils/CurrentContext";
import AxisGizmo from "../commonItems/axisGizmo";
import MeasureTool from "./measureTool";

const Cameras = () => {
  const { orbitCamera, setOrbitCamera, autoRotate,current} = useContext(CurrentContext);

  // References for the cameras
  const stationaryCameraRef = useRef();
  const orbitCameraRef = useRef();

  useFrame(() => {
    if (orbitCamera === false) {
      stationaryCameraRef.current?.lookAt(0, 1, 0);
    }
  });

  return (
    <>
      {/* Stationary Camera */}
      {orbitCamera === false && (
        <PerspectiveCamera
          ref={stationaryCameraRef}
          position={[-1, 1.5, 5]}
          fov={(current === "vaultdoorblockade" || current === "vaultdoorbeast") ? 40 : 30}
          makeDefault
        />
      )}

      {/* Orbit Control Camera */}
      {orbitCamera === true && (
        <>
          <PerspectiveCamera
            ref={orbitCameraRef}
            position={[-1, 1.5, 5]}
            fov={(current === "vaultdoorblockade" || current === "vaultdoorbeast") ? 40 : 30}
            makeDefault
          />
          <OrbitControls
            camera={orbitCameraRef.current}
            autoRotate={autoRotate}
            autoRotateSpeed={4}
            minDistance={1}
            maxDistance={12}
            minPolarAngle={0}
            // maxPolarAngle={Math.PI / 2.25}
            target={[0, 0.75, 0]}
          />
        </>
      )}
    </>
  );
};

export default function Viewer3d({
  models,
  baseModel,
  currentVariant,
  lockType,
}) {
  const light = 180;
  const [showPerformace, setShowPerformace] = useState(false);
  const [showLight, setShowLight] = useState(false);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.altKey && (event.key === "p" || event.key === "P")) {
        setShowPerformace((prevKeyPressed) => !prevKeyPressed);
      }
    };
    const handleShowLightKeyPress = (event) => {
      if (event.altKey && (event.key === "k" || event.key === "K")) {
        setShowLight((showLight) => !showLight);
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    window.addEventListener("keydown", handleShowLightKeyPress);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("keydown", handleShowLightKeyPress);
    };
  }, []);
  const { current } = useContext(CurrentContext);

  const defaultModel = {
    ...models?.[baseModel],
  };
  const Model = models?.[current]?.model || defaultModel?.model;
  const measureToolProps =
    models?.[current]?.measureToolProps || defaultModel?.measureToolProps;

  if (!Model) return null;
  return (
    <div
      id="modelViewerWrapper"
      className="App"
      style={{ width: "100%", height: "100dvh" }}
    >
      <Canvas
        shadows
        style={{ background: "#ffffff" }}
        gl={{ preserveDrawingBuffer: true }}
        // camera={{ fov: 30, position: [-1, 1.5, 5] }}
      >
        {/* fix for black BG appering in screengrab of PDF */}
        <color attach="background" args={["white"]} />

        <Cameras />

        <AxisGizmo />

        <Environment
          files="hdri/1.hdr"
          background={false}
          blur={1}
          children={true}
          backgroundIntensity={0.2}
          environmentIntensity={0.2}
          environmentRotation={[0, (Math.PI / 180) * light, 0]}
          backgroundRotation={[0, (Math.PI / 180) * light, 0]}
        />

        {/* <directionalLight position={[0,0,1] } intensity={3}/> */}


        <Model {...{ currentVariant, lockType }} />

        <MeasureTool {...measureToolProps} />

        {showPerformace && <Perf position={"bottom-left"} />}

        <EffectComposer>
          <BrightnessContrast
            brightness={0.05} //{brightness}//{0.125}
            contrast={0.02} //{contrast}//{0.175}
          />
        </EffectComposer>
      </Canvas>
    </div>
  );
}
